import { GridCellParams, GridColDef } from '@mui/x-data-grid-pro';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ProjectNameCell from './Cells/ProjectNameCell/ProjectNameCell';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import Scope from 'types/entities/Scope';
import User from 'types/entities/User';
import WorkunitComplexity from 'types/entities/WorkunitComplexity';
import Dashboard from 'types/entities/Dashboard';
import ActionsCell from './Cells/ActionsCell/ActionsCell';
import EngagementNameCell from './Cells/EngagementNameCell/EngagementNameCell';
import OrderTypeCell from './Cells/OrderTypeCell/OrderTypeCell';
import ClientCell from './Cells/ClientCell/ClientCell';
import OtpCell from './Cells/OtpCell/OtpCell';
import TypeCell from './Cells/TypeCell/TypeCell';
import OverdueByCell from './Cells/OverdueByCell/OverdueByCell';
import IDCell from './Cells/IDCell/IDCell';

type TodoTableGridCellParams<T> = GridCellParams<Dashboard, T, any>;

export const field = {
  PROJECT_NAME: 'project_name',
  ENGAGEMENT_NAME: 'engagement_name',
  CLIENT: 'client_name',
  OTP: 'otp',
  OVERDUE_BY: 'overdue_by',
  TYPE: 'type',
  ACTIONS: 'action_name',
  ORDER_TYPE: 'order_type',
  ID: 'id',
} as const;

// const defaultColumnParams: GridColDef = {
//   field: '',
//   headerName: '',
//   align: 'left',
//   headerAlign: 'center',
//   filterable: false,
//   sortable: true,
//   flex: 1,
// };

export const useColumnsParams = (data: any[]): GridColDef[] => {
  const [t] = useTranslation();
  const getMaxWidth = (field: string, base = 100) =>
    Math.max(...data.map((row) => (row[field] ? String(row[field]).length * 10 : 0)), base) + 20;

  return [
    {
      field: field.PROJECT_NAME,
      headerName: t('Project_Name'),
      renderCell: (params: TodoTableGridCellParams<null>) => <ProjectNameCell {...params.row} />,
      resizable: true,
      minWidth: 320,
    },
    {
      field: field.ENGAGEMENT_NAME,
      headerName: t('Engagement_Name'),
      renderCell: (params: TodoTableGridCellParams<null>) => <EngagementNameCell {...params.row} />,
      resizable: true,
      minWidth: 320,
    },
    {
      field: field.ORDER_TYPE,
      headerName: t('Engagement_Model'),
      renderCell: (params: TodoTableGridCellParams<null>) => <OrderTypeCell {...params.row} />,
      resizable: true,
      minWidth: 180,
    },
    {
      field: field.CLIENT,
      headerName: t('Customer'),
      renderCell: (params: TodoTableGridCellParams<null>) => <ClientCell {...params.row} />,
      resizable: true,
      minWidth: getMaxWidth(field.CLIENT, 200),
    },
    {
      field: field.OTP,
      headerName: t('OTP'),
      renderCell: (params: TodoTableGridCellParams<null>) => <OtpCell {...params.row} />,
      resizable: true,
      minWidth: getMaxWidth(field.OTP, 120),
    },
    {
      field: field.OVERDUE_BY,
      headerName: t('Overdue_by'),
      renderCell: (params: TodoTableGridCellParams<null>) => <OverdueByCell {...params.row} />,
      resizable: true,
      minWidth: getMaxWidth(field.OVERDUE_BY, 100),
    },
    {
      field: field.TYPE,
      headerName: t('Type'),
      renderCell: (params: TodoTableGridCellParams<null>) => <TypeCell {...params.row} />,
      resizable: true,
      minWidth: getMaxWidth(field.TYPE, 150),
    },
    {
      field: field.ACTIONS,
      headerName: t('Actions'),
      renderCell: (params: TodoTableGridCellParams<null>) => <ActionsCell {...params.row} />,
      resizable: true,
      // align: 'center',
      // headerAlign: 'center',
      minWidth: 200,
      // disableColumnMenu: true,
    },
    // ...repeat for other columns
  ];
};
